// src/components/PermissionsPrompt.jsx
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const LEGAL_ROUTES = ["/terms", "/privacy", "/cookies"];

const PermissionsPrompt = () => {
  const [accepted, setAccepted] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const consentGiven = localStorage.getItem("user_consent");
    if (consentGiven === "true") {
      setAccepted(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("user_consent", "true");
    setAccepted(true);
  };

  const currentPath = location.pathname.replace(/\/$/, "");

  const isLegalPage = LEGAL_ROUTES.some(
    (route) => currentPath === route || currentPath.startsWith(`${route}/`)
  );

  // Do not show the popup if:
  // 1. User already accepted
  // 2. User is reading Terms, Privacy, or Cookies pages
  if (accepted || isLegalPage) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 px-4">
      <div className="w-full max-w-md rounded-xl bg-white p-6 text-center shadow-lg">
        <h2 className="mb-3 text-lg font-bold">Permissions & Consent</h2>

        <p className="mb-2 text-sm">
          This web app uses your internet connection to sync data in real time.
          We also collect analytics and use cookies to improve your experience.
        </p>

        <p className="mb-4 text-sm">
          By clicking "Accept", you agree to our{" "}
          <Link
            to="/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            Terms of Use
          </Link>
          ,{" "}
          <Link
            to="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            Privacy Policy
          </Link>
          , and{" "}
          <Link
            to="/cookies"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            Cookies Policy
          </Link>
          .
        </p>

        <button
          type="button"
          onClick={handleAccept}
          className="rounded-full bg-primary px-5 py-2 font-medium text-white transition hover:bg-orange-700"
        >
          Accept
        </button>
      </div>
    </div>
  );
};

export default PermissionsPrompt;